import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActivityRoutesNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19.78 5.17h1.47a3.4 3.4 0 00-3.22-2.34h-5.2v1.34h5.2a2.04 2.04 0 011.75 1zm1.59 1.66H20a2.079 2.079 0 01-2 1.5h-5.17v1.34h5.2a3.4 3.4 0 003.34-2.84zM7.5 8.34a6.446 6.446 0 00-6.16 5.83H2.7a5.11 5.11 0 015.06-4.5h3.41V8.33H7.5v.01zm.21 11.54a5.105 5.105 0 01-4.94-4.05H1.4a6.46 6.46 0 006.31 5.4h3.46v-1.35H7.71zm15.33-1.29a3.19 3.19 0 00-5.08 0c-.286.38-.481.822-.57 1.29h-4.56v1.35h4.58c.102.426.29.828.55 1.18a3.189 3.189 0 005.08 0 3.21 3.21 0 000-3.82zm-1.08 3a1.89 1.89 0 01-2.92 0 1.791 1.791 0 010-2.18 1.81 1.81 0 012.92 0 1.791 1.791 0 010 2.18zm-15.92-20a3.19 3.19 0 00-5.08 0 3.21 3.21 0 000 3.82 3.19 3.19 0 005.08 0c.278-.366.47-.79.56-1.24h4.57V2.83H6.6a3.033 3.033 0 00-.56-1.24zm-1.08 3a1.89 1.89 0 01-2.92 0 1.791 1.791 0 010-2.18 1.81 1.81 0 012.92 0 1.791 1.791 0 010 2.18z"
        fill=""
      />
    </svg>
  )
);
SvgActivityRoutesNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActivityRoutesNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActivityRoutesNormalSmall;
